import { Decision } from '@/interfaces/decision';
import { DecisionResource, decisionResource } from '@/resources/decision.resource';
import { EntityModule } from './entity.module';

/**
 * Moduł decyzji
 *
 * @export
 * @class DecisionModule
 * @extends {EntityModule<Decision, DecisionResource>}
 */
export class DecisionModule extends EntityModule<Decision, DecisionResource> {
  constructor() {
    super(decisionResource);
  }
}

export default new DecisionModule();
